module.exports = __webpack_public_path__ + "static/media/dummy-mommy.ac3aefe7.md";